// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --app-vh: 1vh;
  --app-viewport-height: 100vh;
  --app-header-height: 58px;
  --app-control-height: 64px;
  --app-safe-top: env(safe-area-inset-top, 0px);
  --app-safe-right: env(safe-area-inset-right, 0px);
  --app-safe-bottom: env(safe-area-inset-bottom, 0px);
  --app-safe-left: env(safe-area-inset-left, 0px);
  --app-mobile-gutter: clamp(10px, 3.6vw, 18px);
  --app-touch-size: 44px;
}

@supports (height: 100dvh) {
  :root {
    --app-viewport-height: 100dvh;
  }
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  text-size-adjust: 100%;
  scroll-padding-top: calc(var(--app-safe-top) + 62px);
}

body,
#root {
  width: 100%;
  max-width: 100%;
  min-height: var(--app-viewport-height);
  overflow-x: clip;
}

body {
  margin: 0;
  -webkit-tap-highlight-color: transparent;
}

img,
video,
svg,
canvas {
  max-width: 100%;
}

button,
[role=button],
a,
input,
select,
textarea {
  touch-action: manipulation;
}

:where(input, select) {
  min-height: var(--app-touch-size);
}

:where(input, select, textarea) {
  max-width: 100%;
}

@media (max-width: 900px) {
  body {
    overscroll-behavior-y: contain;
  }
  input,
  select,
  textarea {
    font-size: 16px !important;
  }
  button,
  [role=button] {
    min-width: var(--app-touch-size);
  }
  .MuiDialog-root .MuiDialog-paper,
  .MuiModal-root .MuiPaper-root {
    width: min(100% - 20px, 720px) !important;
    max-width: calc(100vw - 20px) !important;
    max-height: calc(var(--app-viewport-height) - var(--app-safe-top) - var(--app-safe-bottom) - 20px) !important;
    margin: 10px !important;
    border-radius: 14px !important;
  }
  .MuiTableContainer-root {
    max-width: 100%;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }
  .MuiTabs-root {
    min-height: 46px !important;
  }
  .MuiTabs-scroller {
    overflow-x: auto !important;
    scrollbar-width: none;
  }
  .MuiTabs-scroller::-webkit-scrollbar {
    display: none;
  }
  .MuiTab-root {
    min-height: 44px !important;
    min-width: max-content !important;
    padding-inline: 14px !important;
  }
  .recharts-responsive-container,
  .recharts-wrapper,
  .recharts-surface {
    max-width: 100% !important;
  }
}
@media (max-width: 600px) {
  :root {
    --app-header-height: 54px;
    --app-control-height: 62px;
  }
  body:not(.keyboard-open) {
    padding-bottom: var(--app-safe-bottom);
  }
  h1,
  h2,
  h3,
  p,
  li,
  button,
  label,
  span {
    overflow-wrap: break-word;
  }
  .mobile-horizontal-scroll,
  [data-mobile-scroll=x] {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
    scrollbar-width: thin;
  }
  body.keyboard-open [data-hide-when-keyboard=true] {
    display: none !important;
  }
}
@media (orientation: portrait) and (max-width: 900px) {
  body.is-mobile {
    --app-scene-top: calc(var(--app-safe-top) + 52px);
  }
}
@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto !important;
  }
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
/* Compact native controls define their own visual size. A global button min-height
   stretched playback icons and tool buttons into vertical pills. */
:where(.pb-btn, .pb-speed, .energy-btn, .gesture-btn, .passwordToggle, .TestBtn) {
  min-height: 0;
  min-width: 0;
}

/* Shared containment guard for long localized labels and shadowed buttons. */
:where(button, [role=button]) {
  box-sizing: border-box;
  max-inline-size: 100%;
  min-inline-size: 0;
  white-space: normal;
}

:where(button, [role=button]) > span {
  min-inline-size: 0;
  max-inline-size: 100%;
  overflow-wrap: break-word;
  word-break: normal;
  hyphens: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/mobileApp.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,4BAAA;EACA,yBAAA;EACA,0BAAA;EACA,6CAAA;EACA,iDAAA;EACA,mDAAA;EACA,+CAAA;EACA,6CAAA;EACA,sBAAA;AAFF;;AAKA;EACE;IACE,6BAAA;EAFF;AACF;AAKA;;;EAGE,sBAAA;AAHF;;AAMA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EAEA,sBAAA;EACA,oDAAA;AAHF;;AAMA;;EAEE,WAAA;EACA,eAAA;EACA,sCAAA;EACA,gBAAA;AAHF;;AAMA;EACE,SAAA;EACA,wCAAA;AAHF;;AAMA;;;;EAIE,eAAA;AAHF;;AAMA;;;;;;EAME,0BAAA;AAHF;;AAMA;EACE,iCAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE;IACE,8BAAA;EAHF;EAOA;;;IAGE,0BAAA;EALF;EAQA;;IAEE,gCAAA;EANF;EASA;;IAEE,yCAAA;IACA,wCAAA;IACA,6GAAA;IACA,uBAAA;IACA,8BAAA;EAPF;EAUA;IACE,eAAA;IACA,2BAAA;IACA,iCAAA;EARF;EAWA;IACE,2BAAA;EATF;EAYA;IACE,2BAAA;IACA,qBAAA;EAVF;EAaA;IACE,aAAA;EAXF;EAcA;IACE,2BAAA;IACA,iCAAA;IACA,+BAAA;EAZF;EAeA;;;IAGE,0BAAA;EAbF;AACF;AAgBA;EACE;IACE,yBAAA;IACA,0BAAA;EAdF;EAiBA;IACE,sCAAA;EAfF;EAkBA;;;;;;;;IAQE,yBAAA;EAhBF;EAoBA;;IAEE,WAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,iCAAA;IACA,8BAAA;IACA,qBAAA;EAlBF;EAqBA;IACE,wBAAA;EAnBF;AACF;AAsBA;EACE;IACE,iDAAA;EApBF;AACF;AAuBA;EACE;IACE,gCAAA;EArBF;EAwBA;;;IAGE,gCAAA;IACA,qCAAA;IACA,uCAAA;IACA,sCAAA;EAtBF;AACF;AAyBA;mEAAA;AAEA;EACE,aAAA;EACA,YAAA;AAvBF;;AA0BA,6EAAA;AACA;EACE,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAvBF;;AA0BA;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAvBF","sourcesContent":["// CyberFit portrait-first mobile foundation.\n// Imported once from index.tsx. Page-specific responsive rules remain in their modules.\n\n:root {\n  --app-vh: 1vh;\n  --app-viewport-height: 100vh;\n  --app-header-height: 58px;\n  --app-control-height: 64px;\n  --app-safe-top: env(safe-area-inset-top, 0px);\n  --app-safe-right: env(safe-area-inset-right, 0px);\n  --app-safe-bottom: env(safe-area-inset-bottom, 0px);\n  --app-safe-left: env(safe-area-inset-left, 0px);\n  --app-mobile-gutter: clamp(10px, 3.6vw, 18px);\n  --app-touch-size: 44px;\n}\n\n@supports (height: 100dvh) {\n  :root {\n    --app-viewport-height: 100dvh;\n  }\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n  scroll-padding-top: calc(var(--app-safe-top) + 62px);\n}\n\nbody,\n#root {\n  width: 100%;\n  max-width: 100%;\n  min-height: var(--app-viewport-height);\n  overflow-x: clip;\n}\n\nbody {\n  margin: 0;\n  -webkit-tap-highlight-color: transparent;\n}\n\nimg,\nvideo,\nsvg,\ncanvas {\n  max-width: 100%;\n}\n\nbutton,\n[role=\"button\"],\na,\ninput,\nselect,\ntextarea {\n  touch-action: manipulation;\n}\n\n:where(input, select) {\n  min-height: var(--app-touch-size);\n}\n\n:where(input, select, textarea) {\n  max-width: 100%;\n}\n\n@media (max-width: 900px) {\n  body {\n    overscroll-behavior-y: contain;\n  }\n\n  // Prevent iOS from zooming forms and keep keyboard interaction predictable.\n  input,\n  select,\n  textarea {\n    font-size: 16px !important;\n  }\n\n  button,\n  [role=\"button\"] {\n    min-width: var(--app-touch-size);\n  }\n\n  .MuiDialog-root .MuiDialog-paper,\n  .MuiModal-root .MuiPaper-root {\n    width: min(100% - 20px, 720px) !important;\n    max-width: calc(100vw - 20px) !important;\n    max-height: calc(var(--app-viewport-height) - var(--app-safe-top) - var(--app-safe-bottom) - 20px) !important;\n    margin: 10px !important;\n    border-radius: 14px !important;\n  }\n\n  .MuiTableContainer-root {\n    max-width: 100%;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .MuiTabs-root {\n    min-height: 46px !important;\n  }\n\n  .MuiTabs-scroller {\n    overflow-x: auto !important;\n    scrollbar-width: none;\n  }\n\n  .MuiTabs-scroller::-webkit-scrollbar {\n    display: none;\n  }\n\n  .MuiTab-root {\n    min-height: 44px !important;\n    min-width: max-content !important;\n    padding-inline: 14px !important;\n  }\n\n  .recharts-responsive-container,\n  .recharts-wrapper,\n  .recharts-surface {\n    max-width: 100% !important;\n  }\n}\n\n@media (max-width: 600px) {\n  :root {\n    --app-header-height: 54px;\n    --app-control-height: 62px;\n  }\n\n  body:not(.keyboard-open) {\n    padding-bottom: var(--app-safe-bottom);\n  }\n\n  h1,\n  h2,\n  h3,\n  p,\n  li,\n  button,\n  label,\n  span {\n    overflow-wrap: break-word;\n  }\n\n  // Wide technical content remains usable by panning rather than being illegibly compressed.\n  .mobile-horizontal-scroll,\n  [data-mobile-scroll=\"x\"] {\n    width: 100%;\n    max-width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-x: contain;\n    scrollbar-width: thin;\n  }\n\n  body.keyboard-open [data-hide-when-keyboard=\"true\"] {\n    display: none !important;\n  }\n}\n\n@media (orientation: portrait) and (max-width: 900px) {\n  body.is-mobile {\n    --app-scene-top: calc(var(--app-safe-top) + 52px);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto !important;\n  }\n\n  *,\n  *::before,\n  *::after {\n    scroll-behavior: auto !important;\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* Compact native controls define their own visual size. A global button min-height\n   stretched playback icons and tool buttons into vertical pills. */\n:where(.pb-btn, .pb-speed, .energy-btn, .gesture-btn, .passwordToggle, .TestBtn) {\n  min-height: 0;\n  min-width: 0;\n}\n\n/* Shared containment guard for long localized labels and shadowed buttons. */\n:where(button, [role=\"button\"]) {\n  box-sizing: border-box;\n  max-inline-size: 100%;\n  min-inline-size: 0;\n  white-space: normal;\n}\n\n:where(button, [role=\"button\"]) > span {\n  min-inline-size: 0;\n  max-inline-size: 100%;\n  overflow-wrap: break-word;\n  word-break: normal;\n  hyphens: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
